import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/FlatButton'

class ConfirmOrCancelDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      text: ''
    }
    this.updateText = this.updateText.bind(this)
  }
  updateText(e) {
    this.setState({ text: e.target.value })
  }

  render() {
    const { text } = this.state
    const { appointment, isOpen, isCompletionOperation, onCancel, onSubmit } = this.props
    return (
      <Dialog
        title={isCompletionOperation ? 'Finalizar Consulta' : 'Cancelar Consulta'}
        open={isOpen}
        modal={false}
        contentStyle={{ maxWidth: 320 }}
        actions={[
          <Button label="Não" secondary onClick={onCancel} />,
          <Button label="Sim" primary onClick={onSubmit.bind(null, appointment ? appointment.appointmentId : null, text)} />
        ]}
        onRequestClose={onCancel}>

        {isCompletionOperation ? 'Deseja marcar essa consulta como finalizada?' : 'Tem certeza que quer cancelar essa consulta?'}

        {/* When cancelling, show textfield to justify cancel */}
        {isCompletionOperation ? null :
          <TextField
            multiLine fullWidth
            hintText="Motivo do cancelamento (opcional)"
            value={text}
            onChange={this.updateText}
          />
        }

      </Dialog>
    )
  }
}

ConfirmOrCancelDialog.propTypes = {
  appointment: PropTypes.object,
  isOpen: PropTypes.bool,
  isCompletionOperation: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
export default ConfirmOrCancelDialog



// WEBPACK FOOTER //
// ./src/components/ConfirmOrCancelDialog/index.js